<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit repair status') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteStatusModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/repair-statuses">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateStatus">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Repair status details') }}
              </h3>
              <p class="form-description-text">{{ $t('Repair status details and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="body">{{ $t('Body') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Body')" class="form-input" id="body" required v-model="status.body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repair-statuses">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
    <repair-status-delete-model :show="deleteStatusModal" @cancelled="deleteStatusModal = false" @confirmed="deleteRepairStatus">
      <template #title>{{ $t('Delete repair status') }}</template>
      {{ $t('Are you sure you want to delete the repair status ?') }}
      {{ $t('All data will be permanently removed') }}.
    </repair-status-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  metaInfo() {
    return {
      title: this.$i18n.t('Edit status'),
    };
  },
  components: {
    RepairStatusDeleteModel: confirmationModel,
  },
  data() {
    return {
      loading: true,
      deleteStatusModal: false,
      status: {
        body: null,
      },
    };
  },
  mounted() {
    this.getStatus();
  },
  methods: {
    deleteRepairStatus() {
      axios
        .delete(route('repair-statuses.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/repair-statuses');
        })
        .catch(() => {
          this.deleteStatusModal = false;
        });
    },
    updateStatus() {
      this.loading = true;
      axios
        .put(route('repair-statuses.update', this.$route.params.id), this.status)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStatus() {
      this.loading = true;
      axios
        .get(route('repair-statuses.show', this.$route.params.id))
        .then((response) => {
          this.status = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
